/* eslint-disable no-invalid-this */
import $ from 'jquery';
import { parseQueryString } from '../../smartpak/url';
import page from '../../smartpak/page';
import { login as reCaptchaLogin } from '../../vendor/recaptcha/recaptcha';
import { spSignIn } from '../../vendor/googletagmanager/spevents/spsignin';
import { clearErrors, ensureUnobtrusiveValidation, parseDynamicFormElements } from '../../validation/unobtrusivehelpers';
import * as emailStore from './emailstore';
import addCapsLockListeners from './capslocklisteners';

export const errorCodes = {
    LOGIN_FAILED: 2,
    LOGIN_FAILED_LONG: 3,
    LOGIN_FAILED_AMBIGUOUS: 4,
    TOO_MANY_ATTEMPTS: 5
};

export function getErrorMessageFromCode(code) {
    if (code === errorCodes.LOGIN_FAILED) {
        return 'Invalid password/email.';
    }

    if (code === errorCodes.LOGIN_FAILED_LONG) {
        return 'There was a problem with this email address/password combination. Please try again, or <a href="/content/contactus">contact us</a> for assistance.';
    }

    if (code === errorCodes.LOGIN_FAILED_AMBIGUOUS) {
        return 'Logged in as multiple customers.';
    }

    if (code === errorCodes.TOO_MANY_ATTEMPTS) {
        return 'We see that you are having trouble logging in. To help keep your SmartPak account safe and secure, <a href="/reset-my-password-request">please click here to confirm your email address and reset your password</a>.';
    }

    return 'An unknown error occurred.';
}

const loginForm = {
    fireLoginEvents: function () {
        spSignIn();

        if (smartPak.cdProfileCookie && smartPak.dynamicYield) {
            smartPak.cdProfileCookie.refreshCookieData();
            smartPak.dynamicYield.audienceEvent(smartPak.cdProfileCookie, true);
            smartPak.dynamicYield.loginEvent(smartPak.cdProfileCookie.CustomerEmail);
        }
    },
    validate: function (data, success) {
        $.post('/account/jsonlogin', data)
            .done(response => {
                if (!response.loginSuccessful) {
                    this.showErrorMessage(getErrorMessageFromCode(response.loginState));
                    return;
                }

                if (typeof success === 'function') {
                    success(response.customerChanged);
                }
            })
            .fail(function () {
                window.location.href = '/';
            });
    },
    parseQueryString: query => parseQueryString(query),
    showErrorMessage: function (errorMessage) {
        var $loginForm = $('#loginForm'),
            $summary = $loginForm.find('.validation-summary-valid, .validation-summary-errors').eq(0);

        $summary
            .removeClass('validation-summary-valid validation-summary-errors')
            .addClass('validation-summary-errors');

        $summary
            .find('ul')
            .empty()
            .append('<li>' + errorMessage + '</li>');
    },
    _cleanPassword: function () {
        var $password = $('#Password'),
            val = $password.val();

        if (val) {
            $password.val(val.trim());
        }
    },
    defaultSubmit: function () {
        var search = this.parseQueryString(location.search),
            DEFAULT_URL = '/',
            returnUrl = null;

        if (search) {
            if (search.returnUrl) {
                returnUrl = search.returnUrl;
            } else if (search.ReturnUrl) {
                returnUrl = search.ReturnUrl;
            }
        }

        page.redirectToUrl(search && returnUrl ? decodeURIComponent(returnUrl) : DEFAULT_URL);
    },
    bindEvents: function () {
        this.$form
            .on('click', '#login', event => {
                event.preventDefault();
                this._cleanPassword();
                this.handleSubmitBtnClick($(event.target));
            })
            .on('keydown', '#UserName, #Password', event => {
                this._handleEnterKeyPress(event.keyCode ? event.keyCode : event.which);
            })
            .on('focus', '#UserName, #Password', () => {
                clearErrors(this.$form);
            })
            .on('click', '#forgotPW', event => {
                this.handleForgotPWClick(event);
            })
            .on('click', '.pwd-toggle-show', function (e) {
                e.preventDefault();
                $('#Password').prop('type', 'text');
                $(this).addClass('jsHide');
                $('.pwd-toggle-hide').removeClass('jsHide');
            })
            .on('click', '.pwd-toggle-hide', function (e) {
                e.preventDefault();
                $('#Password').prop('type', 'password');
                $(this).addClass('jsHide');
                $('.pwd-toggle-show').removeClass('jsHide');
            });
    },
    _handleEnterKeyPress: function (keyCode) {
        var ENTERKEYCODE = 13;

        if (keyCode === ENTERKEYCODE) {
            this.$formSubmitBtn.trigger('click');
        }
    },
    handleSubmitBtnClick: async function () {
        this.$form.find('#HasPassword').val('true'); // no idea why this is required.

        const onSuccess = () => {
            this.fireLoginEvents();
            this.onSuccess();
        };

        const submit = () => {
            this.validate(this.$form.serialize(), onSuccess, () => this.onFailure());
        };

        if (this.$form.valid()) {
            const token = await reCaptchaLogin();

            this.$form.find('#Token').val(token);
            submit();
        }
    },
    handleForgotPWClick: function (event) {
        event.preventDefault();

        emailStore.set($('#UserName').val());

        page.redirectToUrl($(event.currentTarget).attr('href'));
    },
    setupFormValidation: async function () {
        await ensureUnobtrusiveValidation();

        parseDynamicFormElements(this.$form);
    },
    init: function (success, fail) {
        // eslint-disable-next-line no-empty-function
        this.onFailure = typeof fail === 'function' ? fail : function () { };
        this.onSuccess = typeof success === 'function' ? success : this.defaultSubmit;
        this.$form = $('#loginForm');
        this.$formSubmitBtn = this.$form.find('#login');
        this.setupFormValidation();
        this.bindEvents();
        addCapsLockListeners(this.$form[0].querySelectorAll('#UserName, #Password'));
    }
};

export default loginForm;
